export default {
  '_b._qhyy': 'Palitan ang Wika',

  '_a._jzz': 'Naglo-load...',
  '_a._jzgd': 'Mag-load Pa',
  '_a._wct': 'Maligayang Pagdating sa',
  '_a._gd': 'Higit Pa',
  '_a._bf': 'I-play',
  '_a._bcz': 'Sinesave...',
  '_a._sctp': 'Mag-upload ng Larawan',

  '_dl._qssyx': 'Pakilagay ang iyong email',
  '_dl._qssmm': 'Pakilagay ang iyong password',
  '_dl._ann': 'Mag-login',
  '_dl._hmyzh': 'Walang account?',
  '_dl._qzc': 'Magrehistro',
  '_dl._yzhl': 'Mayroon nang account?',
  '_dl._qdl': 'Mag-login',
  '_dl._srqrmm': 'Pakikonpirma ang password',
  '_dl._sryqm': 'Pakilagay ang invitation code',
  '_dl._sryzm': 'Pakilagay ang verification code',
  '_dl._ljzc': 'Magrehistro Ngayon',
  '_dl._zcbsty': 'Ang pagrehistro ay nangangahulugang nabasa at sumasang-ayon sa',
  '_dl._yszc': 'Patakaran sa Privacy',
  '_dl._lcmmbyy': 'Hindi magkatugma ang mga password',

  '_yzm._fsyzm': 'Magpadala ng Verification Code',
  '_yzm._cxfs': '({time}) Muling Magpadala',
  '_yzm._fsz': 'Nagpapadala...',
  '_yzm._fscg': 'Matagumpay na Naipadala',

  '_h._zrm': 'Pinakasikat',
  '_h._zxd': 'Pinakabago',
  '_h._phb': 'Ranking',
  '_h._qz': 'Wallpaper',
  '_h._ssww': 'Maghanap',
  '_h._lsjl': 'Kasaysayan',
  '_h._gd': 'Higit Pa',
  '_h._dl': 'Mag-login',
  '_h._ye': 'Balanse',
  '_h._dj': 'Na-freeze',
  '_h._ybp': 'Dashboard',
  '_h._wdqb': 'Aking Wallet',
  '_h._scjl': 'Mga Paborito',
  '_h._xxzx': 'Message Center',
  '_h._fxhy': 'Ibahagi sa Mga Kaibigan',
  '_h._bzzx': 'Help Center',
  '_h._ggtf': 'Paglalagay ng Ad',
  '_h._bqtz': 'Pamumuhunan sa Copyright',
  '_h._sz': 'Mga Setting',

  '_sy._jx': 'Featured',
  '_sy._xpfb': 'Mga Bagong Release',
  '_sy._gdsp': 'Marami Pang Video',

  '_qz._jbqz': 'Koleksyon ng Magagandang Wallpaper',
  '_qz._ssqz': 'Maghanap ng Wallpaper',
  '_qz._qb': 'Lahat',
  '_qz._zrfg': 'Mga Likas na Tanawin',
  '_qz._cxys': 'Abstract Art',
  '_qz._csjz': 'Urban Architecture',
  '_qz._dmyx': 'Anime at Mga Laro',
  '_qz._yzxk': 'Kosmos at Mga Bituin',
  '_qz._yl': 'Preview',
  '_qz._xzqz': 'I-download ang Wallpaper',
  '_qz._fbl': 'Resolution',
  '_qz._fl': 'Kategorya',
  '_qz._jzz': 'Naglo-load',
  '_qz._myzdpp': 'Walang Nahanap na Wallpaper',

  '_sp._xyjscl': 'Kailangang i-unlock para mapanood',
  '_sp._cz': 'Mag-load',
  '_sp._jsqj': 'I-unlock ang Lahat ng Episode',
  '_sp._jsbj': 'I-unlock ang Episode na Ito',
  '_sp._sc': 'Paborito',
  '_sp._fx': 'Ibahagi',
  '_sp._jsqjjs': 'Kumpirmahin ang pagbabayad ng {a} para i-unlock ang lahat ng episode?',
  '_sp._jsbjjs': 'Kumpirmahin ang pagbabayad ng {a} para i-unlock ang episode na ito?',
  '_sp._zfz': 'Pinoproseso ang Bayad...',
  '_sp._qrzf': 'Kumpirmahin ang Bayad',
  '_sp._qx': 'Kanselahin',

  '_qz._smrc': 'Pagsikat ng Araw sa Bundok',
  '_qz._cxjh': 'Abstract Geometry',
  '_qz._dsyj': 'Tanawin ng Gabi sa Lungsod',
  '_qz._dmfj': 'Tanawin ng Anime',
  '_qz._hhxk': 'Malawak na Langit',
  '_qz._slmw': 'Hamog sa Gubat',
  '_qz._scld': 'Daloy ng Kulay',
  '_qz._xdjz': 'Modernong Arkitektura',

  '_qb._cbjl': 'Kasaysayan ng Deposito',
  '_qb._jyjl': 'Kasaysayan ng Transaksyon',
  '_qb._bddz': 'Mga Naka-link na Address',
  '_qb._txjl': 'Kasaysayan ng Withdrawal',

  '_m._tcdl': 'Mag-logout',
  '_m._cb': 'Magdeposito',
  '_m._tb': 'Mag-withdraw',

  '_cb._ssdz': 'Maghanap ng Currency o Address',
  '_cb._bz': 'Currency',
  '_cb._je': 'Halaga',
  '_cb._dz': 'Address',
  '_cb._sj': 'Oras',
  '_cb._cz': 'Aksyon',
  '_cb._zwjl': 'Walang Transaksyon Pa',
  '_cb._dny': 'Pahina {a} ng {b}',
  '_cb._jyxq': 'Mga Detalye ng Transaksyon',
  '_cb._jydz': 'Address ng Transaksyon',
  '_cb._zt': 'Katayuan',
  '_cb._yqr': 'Nakumpirma',
  '_cb._qb': 'Lahat',
  '_cb._jt': 'Ngayon',
  '_cb._j7t': 'Nakaraang 7 Araw',
  '_cb._j30t': 'Nakaraang 30 Araw',
  '_cb._zw': 'Wala',
  '_cb._fzcg': 'Nakopya ang Address sa Clipboard',

  '_jyjl._ssdz': 'Maghanap ng Currency o Address',
  '_jyjl._lx': 'Uri',
  '_jyjl._je': 'Halaga',
  '_jyjl._ye': 'Balanse',
  '_jyjl._dj': 'Na-freeze',
  '_jyjl._sj': 'Oras',
  '_jyjl._cz': 'Aksyon',
  '_jyjl._zwjyjl': 'Walang Transaksyon Pa',
  '_jyjl._czsx': 'I-reset ang Filter',
  '_jyjl._dny': 'Pahina {a} ng {b}',
  '_jyjl._jyxq': 'Mga Detalye ng Transaksyon',
  '_jyjl._jylx': 'Uri ng Transaksyon',
  '_jyjl._jyje': 'Halaga ng Transaksyon',
  '_jyjl._jyhye': 'Balanse Pagkatapos ng Transaksyon',
  '_jyjl._djye': 'Halagang Na-freeze',
  '_jyjl._jysj': 'Oras ng Transaksyon',
  '_jyjl._jyzt': 'Katayuan ng Transaksyon',
  '_jyjl._ywc': 'Natapos',
  '_jyjl._qb': 'Lahat',
  '_jyjl._jt': 'Ngayon',
  '_jyjl._j7t': 'Nakaraang 7 Araw',
  '_jyjl._j30t': 'Nakaraang 30 Araw',

  '_jyjl._tp1': 'Deposito',
  '_jyjl._tp2': 'Withdraw',
  '_jyjl._tp3': 'Bayad',
  '_jyjl._tp4': 'Deposito',
  '_jyjl._tp5': 'I-freeze',
  '_jyjl._tp6': 'Kita',
  '_jyjl._tp7': 'Reward sa Pag-imbita',
  '_jyjl._tp8': 'Reward sa Pag-login',
  '_jyjl._tp9': 'Kita sa Promosyon',
  '_jyjl._tp10': 'Reward sa Video',
  '_jyjl._tp11': 'Bonus sa Pagrehistro',
  '_jyjl._tp12': 'Tinanggihan ang pag-withdraw',
  '_jyjl._tp13': 'Pulang Pakete ng Mensahe',

  '_jyjl._tp14': 'Panloob na Paglilipat',

  '_cb._shz': 'Sinusuri',
  '_cb._yyg': 'Naaprubahan',
  '_cb._ybh': 'Tinanggihan',

  '_bddz._tjdz': 'Magdagdag ng Address',
  '_bddz._ssdz': 'Maghanap ng Address',
  '_bddz._bz': 'Currency',
  '_bddz._dz': 'Address',
  '_bddz._sysj': 'Huling Ginamit',
  '_bddz._cz': 'Aksyon',
  '_bddz._zwjl': 'Walang Address Pa',
  '_bddz._dny': 'Pahina {a} ng {b}',
  '_bddz._dzewm': 'QR Code ng Address',
  '_bddz._fzdz': 'Kopyahin ang Address',
  '_bddz._dzxq': 'Mga Detalye ng Address',
  '_bddz._wl': 'Network',
  '_bddz._tjsj': 'Oras ng Pagdagdag',
  '_bddz._bzwa': 'Tala',
  '_bddz._ntq': '{a} araw ang nakalipas',
  '_bddz._nxsq': '{a} oras ang nakalipas',
  '_bddz._nfzq': '{a} minuto ang nakalipas',
  '_bddz._ngg': 'Ngayon lang',
  '_bddz._dzyfz': 'Nakopya ang Address sa Clipboard',
  '_bddz._scqr': 'Kumpirmasyon sa Pagbura',
  '_bddz._scqrdz': 'Sigurado ka bang gusto mong burahin ang address na ito?',
  '_bddz._qr': 'Kumpirmahin',
  '_bddz._qx': 'Kanselahin',
  '_bddz._scdzcg': 'Matagumpay na Nabura ang Address',

  '_txjl._ztsx': 'Filter ng Katayuan',
  '_txjl._qbzt': 'Lahat ng Katayuan',
  '_txjl._shz': 'Sinusuri',
  '_txjl._ytg': 'Naaprubahan',
  '_txjl._yjj': 'Tinanggihan',
  '_txjl._ssdz': 'Maghanap ng Address o Halaga',
  '_txjl._bz': 'Currency',
  '_txjl._je': 'Halaga',
  '_txjl._dz': 'Address',
  '_txjl._zt': 'Katayuan',
  '_txjl._sj': 'Oras',
  '_txjl._cz': 'Aksyon',
  '_txjl._zwjl': 'Walang Transaksyon Pa',
  '_txjl._czsx': 'I-reset ang Filter',
  '_txjl._dny': 'Pahina {a} ng {b}',
  '_txjl._jyxq': 'Mga Detalye ng Transaksyon',
  '_txjl._skdz': 'Address ng Pagtanggap',
  '_txjl._jysj': 'Oras ng Transaksyon',
  '_txjl._jyzt': 'Katayuan ng Transaksyon',
  '_txjl._fzdz': 'Nakopya ang Address sa Clipboard',

  '_cbsq._bz': 'Currency',
  '_cbsq._wl': 'Network',
  '_cbsq._erwm': 'QR Code',
  '_cbsq._fzdz': 'Kopyahin ang Address',

  '_txsq._bz': 'Currency',
  '_txsq._wl': 'Network',
  '_txsq._ye': 'Balanse',
  '_txsq._sxf': 'Bayad',
  '_txsq._zxtx': 'Minimum na Withdrawal',
  '_txsq._txdz': 'Address ng Withdrawal',
  '_txsq._qxztxdz': 'Pumili ng Withdrawal Address',
  '_txsq._txje': 'Halaga ng Withdrawal',
  '_txsq._qsrtxje': 'Pakilagay ang halaga ng withdrawal',
  '_txsq._yxyzm': 'Email Verification Code',
  '_txsq._qsryxyzm': 'Pakilagay ang verification code',
  '_txsq._ljtx': 'Mag-withdraw Ngayon',

  '_jl._wxhd': 'Aking Mga Paborito',
  '_jl._lsjl': 'Kasaysayan',

  '_xx._bt': 'Message Center',
  '_xx._wjl': 'Walang Rekord',
  '_xx._zsmyxx': 'Walang Mensahe Pa',
  '_xx._sxxx': 'I-refresh ang Mga Mensahe',
  '_xx._sxcg': 'Matagumpay na Na-refresh',

  '_fx._fxhy': 'Ibahagi sa Mga Kaibigan',
  '_fx._smfx': 'I-scan ang QR Code para Ibahagi sa Mga Kaibigan',
  '_fx._jlsm': 'Deskripsyon ng Reward',
  '_fx._jlsm1': '1. Mga kaibigan na inimbita nang direkta (Level 1) ay magbibigay sa iyo ng {a}% ng kanilang kita.',
  '_fx._jlsm2': '2. Mga kaibigan na inimbita ng iyong Level 1 na kaibigan (Level 2) ay magbibigay sa iyo ng {a}% ng kanilang kita.',
  '_fx._jlsm3': '3. Mga kaibigan na inimbita ng iyong Level 2 na kaibigan (Level 3) ay magbibigay sa iyo ng {a}% ng kanilang kita.',
  '_fx._fzlj': 'Kopyahin ang Link',

  '_bzzx._bzzx': 'Help Center',
  '_bzzx._rhzczh': 'Paano Gumawa ng Account',
  '_bzzx._zclc': 'Proseso ng Pagrehistro',
  '_bzzx._rhzcxyh': 'Paano magrehistro ng bagong account?',
  '_bzzx._rhzcxyh1': 'I-click ang "Magrehistro", ilagay ang iyong email address, itakda ang password, at kumpletuhin ang email verification.',

  '_bzzx._rhcz': 'Paano Mag-load?',
  '_bzzx._rhcz1': 'Proseso ng Pag-load',
  '_bzzx._rhcz2': 'Mga Detalyadong Instruksyon sa Pag-load',
  '_bzzx._rhcz3': 'I-click ang Aking Wallet, Magdeposito, pumili ng cryptocurrency, at ipadala sa ibinigay na address.',

  '_bzzx._rhjsdj': 'Paano I-unlock ang Maikling Drama',
  '_bzzx._rhjsdj2': 'I-click para i-unlock ang mga indibidwal na episode.',

  '_bzzx._rhtx': 'Paano Mag-withdraw mula sa Account',
  '_bzzx._rhtx1': '1. Pumunta sa Aking Wallet, Withdrawal Addresses, magdagdag ng bagong address.<br>2. I-click ang Withdraw, pumili ng currency, ilagay ang halaga, at maghintay.',

  '_bzzx._qtwt': 'Iba Pang Mga Katanungan',
  '_bzzx._qtwt1': 'Paano Makipag-ugnayan sa Suporta?',
  '_bzzx._qtwt2': 'Makipag-ugnayan sa amin sa pamamagitan ng online chat, email, o telepono.',
  '_bzzx._myzdwt': 'Hindi Makita ang Hinahanap na Sagot?',
  '_bzzx._khjybbzn': 'Ang aming koponan ay masayang tutulong sa iyo.',
  '_bzzx._lxkf': 'Makipag-ugnayan sa Suporta',

  '_ggtf._bt1': 'Paglagay ng Ad',
  '_ggtf._splb': 'Listahan ng Video',
  '_ggtf._wcyd': 'Aking Pakikilahok',
  '_ggtf._hdbm': 'Kodigo ng Kaganapan',
  '_ggtf._tian': 'Araw',
  '_ggtf._kssj': 'Oras ng Pagsisimula',
  '_ggtf._jssj': 'Oras ng Pagtatapos',
  '_ggtf._ddvp': 'Umabot sa VIP Level {a}, average na {b} pakikilahok bawat tao',
  '_ggtf._hdzt': 'Katayuan ng Kaganapan',
  '_ggtf._wks': 'Hindi Pa Nagsisimula',
  '_ggtf._ycy': 'Nakalahok',
  '_ggtf._qg': 'Bumili Ngayon',
  '_ggtf._mygdl': 'Wala Nang Iba Pang Data',
  '_ggtf._qgrtd': 'Masyadong Maraming Bumibili, Pakisubukan Muli',
  '_ggtf._hdxq': 'Mga Detalye ng Kaganapan',
  '_ggtf._hdjs': 'Deskripsyon ng Kaganapan',
  '_ggtf._cyyq': 'Mga Kinakailangan sa Pakikilahok',
  '_ggtf._zdtz': 'Minimum na Pamumuhunan',
  '_ggtf._vpdj': 'Antas ng VIP',
  '_ggtf._rjcy': 'Average na Pakikilahok',
  '_ggtf._gmje': 'Halaga ng Pagbili',
  '_ggtf._qsrgmje': 'Pakilagay ang halaga ng pagbili',
  '_ggtf._qx': 'Kanselahin',
  '_ggtf._ljcy': 'Makilahok Ngayon',
  '_ggtf._ssjymm': 'Ilagay ang Transaction Password',
  '_ggtf._qssjymm': 'Pakilagay ang transaction password',
  '_ggtf._ji': 'Antas',
  '_ggtf._ci': 'beses',
  '_ggtf._zdgm': 'Minimum na Halaga ng Pagbili',
  '_ggtf._zggm': 'Maximum na Halaga ng Pagbili',
  '_ggtf._zfz': 'Pinoproseso ang Bayad...',

  '_wdtg._wjl': 'Walang Rekord ng Pakikilahok',
  '_wdtg._tzje': 'Halagang Namuhunan',
  '_wdtg._zsy': 'Kabuuang Kita',
  '_wdtg._hdts': 'Tagal ng Kaganapan',
  '_wdtg._cysj': 'Oras ng Pakikilahok',
  '_wdtg._qzf': 'Pumunta sa Pagbabayad',
  '_wdtg._jxz': 'Isinasagawa',
  '_wdtg._djszje': 'Kabuuang Halagang Nakabinbin',
  '_wdtg._gjb': 'Kabuuang {a} mga Item',
  '_wdtg._djs': 'Nakabinbin',
  '_wdtg._zrsy': 'Kita Kahapon',
  '_wdtg._dbl': 'Mga View sa Video-on-Demand',
  '_wdtg._bfl': 'Bilang ng Pag-play',
  '_wdtg._wdsy': 'Aking Kita',
  '_wdtg._bqffc': 'Bahagi ng May-ari ng Copyright',
  '_wdtg._mr0djs': 'Kita kahapon ay naaayos araw-araw sa 00:00',
  '_wdtg._jrsy': 'Kita Ngayon',
  '_wdtg._mygd': 'Wala Nang Iba Pang Data',

  '_bqyy._bqyy': 'Pag-book ng Pakikipagtulungan sa Copyright',
  '_bqyy._qrbq': 'Kumpirmahin ang booking ng pakikipagtulungan?',
  '_bqyy._qx': 'Kanselahin',
  '_bqyy._tjyy': 'Ipasa ang Booking',

  '_bqyy._spsq': 'Kahilingan sa Pakikipagtulungan sa Copyright ng Video',
  '_bqyy._spsy': 'I-promote ang mga video nang magkasama para sa mas maraming trapiko at kita!',
  '_bqyy._ljyy': 'Mag-book Ngayon',
  '_bqyy._sphz': 'Ano ang Pakikipagtulungan sa Copyright ng Video?',
  '_bqyy._sphzsm': 'Ang pakikipagtulungan ay nagbibigay ng mas maraming visibility para sa mutual na benepisyo.',
  '_bqyy._sqhch': 'Mga Benepisyo ng Pakikipagtulungan',
  '_bqyy._llfz': 'Suporta sa Trapiko',
  '_bqyy._llfzsm': 'Dagdagan ang iyong visibility at mga pag-play.',
  '_bqyy._sytg': 'Dagdag na Kita',
  '_bqyy._sytgsm': 'Makinabang mula sa mas mataas na kita sa ad.',
  '_bqyy._yxhz': 'Priority na Pakikipagtulungan',
  '_bqyy._yxhzsm': 'Makilahok nang priority sa mga opisyal na kaganapan.',
  '_bqyy._yytj': 'Mga Kondisyon sa Pag-book',
  '_bqyy._sptg': 'Mga Kinakailangan sa Pag-promote ng Video',
  '_bqyy._sptgsm': 'Makilahok sa hindi bababa sa 1 promotion ng video.',
  '_bqyy._yysm': 'Ang aming koponan ay makikipag-ugnayan sa loob ng 3 araw ng trabaho.',

  '_ybp._wdsy': 'Aking Kita',
  '_ybp._dqye': 'Kasalukuyang Balanse',
  '_ybp._jr': 'Ngayon',
  '_ybp._jrzsy': 'Kabuuang Kita Ngayon',
  '_ybp._ljzsy': 'Kabuuang Naipon na Kita',
  '_ybp._tgfh': 'Mga Dividend sa Promosyon',
  '_ybp._ljsy': 'Naipong Kita',
  '_ybp._bqsy': 'Kita sa Copyright',
  '_ybp._yqfh': 'Mga Dividend sa Pag-imbita',
  '_ybp._mrsy': 'Araw-araw na Kita',
  '_ybp._tgsy': 'Kita sa Promosyon',

  '_tjdz._tjxd': 'Magdagdag ng Bagong Address',
  '_tjdz._xzbz': 'Pumili ng Currency',
  '_tjdz._qbdz': 'Address ng Wallet',
  '_tjdz._srdz': 'Pakilagay ang address ng wallet',
  '_tjdz._qx': 'Kanselahin',
  '_tjdz._bc': 'I-save',

  '_sz._smrz': 'Pagpapatunay ng Identidad',
  '_sz._rzlx': 'Uri ng Pagpapatunay',
  '_sz._sfzzm': 'Harap ng ID',
  '_sz._sfzfm': 'Likod ng ID',
  '_sz._zsxm': 'Pangalan',
  '_sz._qsrzsxm': 'Pakilagay ang iyong pangalan',
  '_sz._sfzhm': 'Numero ng ID',
  '_sz._qsrsfzhm': 'Pakilagay ang numero ng ID',
  '_sz._yyzz': 'Lisensya sa Negosyo',
  '_sz._qymc': 'Pangalan ng Kumpanya',
  '_sz._yyzzh': 'Numero ng Lisensya sa Negosyo',
  '_sz._qsrqymc': 'Pakilagay ang pangalan ng kumpanya',
  '_sz._qsryyzzh': 'Pakilagay ang numero ng lisensya',
  '_sz._qx': 'Kanselahin',
  '_sz._tjrz': 'Ipasa ang Pagpapatunay',
  '_sz._zt': 'Katayuan',
  '_sz._gr': 'Indibidwal',
  '_sz._qy': 'Kumpanya',
  '_sz._shz': 'Sinusuri',
  '_sz._ytg': 'Naaprubahan',
  '_sz._ybh': 'Tinanggihan',

  '_mm._xgmm': 'Palitan ang Password',
  '_mm._dqxg': 'Regular na palitan ang password para sa seguridad',
  '_mm._dqmm': 'Kasalukuyang Password',
  '_mm._xmm': 'Bagong Password',
  '_mm._qrxmm': 'Kumpirmahin ang Bagong Password',
  '_mm._qx': 'Kanselahin',
  '_mm._qrxg': 'Kumpirmahin ang Pagbabago',

  '_jymm._xgjymm': 'Palitan ang Transaction Password',

  '_szzx._sz': 'Mga Setting',
  '_szzx._yrz': 'Na-verify',
  '_szzx._wrz': 'Hindi Na-verify',
  '_szzx._jymm': 'Transaction Password',
  '_szzx._szjymm': 'Itakda o Palitan ang Transaction Password',
  '_szzx._tcdl': 'Mag-logout',
  '_szzx._qdtcdl': 'Sigurado ka bang gusto mong mag-logout?',
  '_szzx._qrtc': 'Kumpirmahin ang Logout',
  '_szzx._qx': 'Kanselahin',

  '_yj._gy': 'Tungkol Dito',

  '_yj._lxwm': 'Makipag-ugnayan sa Amin',

  '_yj._yszc': 'Patakaran sa Pagkapribado',

  '_yj._yhxy': 'Kasunduan ng Gumagamit',

  '_cd._gszz': 'Mga Kwalipikasyon ng Kumpanya',

  '_cd._wmyy': 'Mayroon kaming kumpletong mga kwalipikasyon at sertipikasyon sa industriya, na nagbibigay sa mga gumagamit ng legal, ligtas, at mataas na kalidad na mga serbisyo sa video',

  '_cd._yyzz': 'Wastong patunay ng legal na operasyon ng kumpanya, na nagpapakita ng aming pormal na impormasyon sa pagpaparehistro at saklaw ng negosyo',

  '_cd._yyzz2': 'Isang lisensya sa negosyo na sertipikado ng kumpanya na legal na nakuha, na tinitiyak ang legalidad at pagsunod sa platform',

  '_bz._lxkf': 'Mag-click sa ibaba upang makipag-ugnayan sa serbisyo sa customer, o makipag-ugnayan sa amin sa pamamagitan ng email o hotline ng serbisyo sa customer',

  '_sz._bjtx': 'I-edit',

  '_sz._bjxx': 'I-edit ang Mensahe',

  '_sz._tx': 'Avatar',

  '_sz._bcun': 'I-save',

  '_db._zskf': 'Makipag-ugnayan sa Suporta',
  '_db._zsry': 'Itinalagang Ahente',
  '_db._wdq': 'Hindi pa Nababasa',
  '_db._ydq': 'Nabasa na',

  '_sc._sctp': 'Mag-upload ng Larawan',
  '_sc._xztp': 'Pumili ng Larawan',
  '_sc._fstp': 'Ipadala ang Larawan',
  '_sc._qx': 'Kanselahin',
  '_sc._hd': 'Sige',

  '_zcyl._zcbt': 'Regalo sa Pagrehistro',
  '_zcyl._djdkhb': 'I-tap para buksan ang red envelope',
  '_zcyl._zclj': 'Bonus sa Pagrehistro',
  '_zcyl._hmyzh': 'Wala pang account?',
  '_zcyl._qzc': 'Magrehistro',
  '_zcyl._qxdjhb': 'Kunin muna ang iyong premyo',
  '_zcyl._qwzc': 'Pumunta sa Pagrehistro',
  '_zcyl._hbysy': 'Nagamit na ang premyo',

  '_ggtg._qhz': 'Pumunta sa Transfer',
  '_ggtg._dqye': 'Kasalukuyang Balanse',
  '_ggtg._qcz': 'Pumunta sa Deposit',
  '_ggtg._hzje': 'Halaga ng Transfer',
  '_ggtg._ljhz': 'Mag-transfer Ngayon',
  '_ggtg._yebz': 'Hindi Sapat na Balanse',

  '_sq._bhbt': 'Tinanggihan',

  '_sq._bhyy': 'Dahilan ng pagtanggi',

  '_xx._ntq': '{n} araw na ang nakalipas',

  '_xx._nxsq': '{n} oras na ang nakalipas',

  '_xx._nfzq': '{n} minuto na ang nakalipas',

  '_xx._nggq': 'Ngayon lang',

  '_xx._djckgd': 'I-click para tingnan ang higit pa',

  '_ct._zt': 'Katayuan',

  '_ct._ljz': 'Kumokonekta',

  '_ct._ylj': 'Konektado',

  '_ct._ltlieb': 'Listahan ng Chat',

  '_ct._bnhzj': 'Hindi maka-chat sa sarili ko',

  '_ct._cylb': 'Listahan ng Miyembro',

  '_hb._fhb': 'Pulang Sobre',

  '_hb._dqye': 'Kasalukuyang Balanse',

  '_hb._fsd': 'Ipinadala kay',

  '_hb._hbje': 'Halaga ng Pulang Sobre',

  '_hb._qshuru': 'Pakilagay ang halaga ng pulang sobre',

  '_hb._ljfs': 'Ipadala Ngayon',

  '_hb._hbz': "Pulang Sobre 'Pagpapala",
  '_hb._qshuruzhu': 'Pakilagay ang iyong pagpapala',

  '_sp._cuow': 'Kailangang ma-unlock ang mga Episode 1-10 bago ka makapanood',

  '_bq._tzzq': 'Panahon ng Pamumuhunan',

  '_bq._zrsy': 'Tubo Kahapon',

  '_bq._bqtz': 'Pamumuhunan sa Karapatang-ari',

  '_bq._tzdj': 'Halaga ng Pamumuhunan',

  '_bq._zfjz': 'Dapat gawin ang pagbabayad sa loob ng 24 oras, kung hindi, ito ay ituturing na isang pagpapaubaya!',

  '_bq._qzf': 'Magbayad',

  '_bq.jz': 'Huling Araw',

  '_bq._ljzf': 'Magbayad Ngayon',

  '_bq._sqbz': 'Mga Tala ng Aplikasyon (Opsyonal)',

  '_bq._sqbzsm': 'Pakilagay ang Mga Tala ng Aplikasyon',

  '_bq._zzsqz': 'Kasalukuyang isinasagawa ang aplikasyon para sa karapatang-ari, naghihintay ng pagsusuri...',

  '_app._xz': 'I-download ang ReelShortBiz application',

  '_app._smerm': 'I-scan ang QR code para mag-download',

  '_app._xzbt': 'I-download',

  '_m._yhzz': 'Bank Transfer',
  '_m._yhxx': 'Bank Information',
  '_m._yhmz': 'Pangalan ng Bangko',
  '_m._yhdz': 'Address ng Bangko',
  '_m._yhmc': 'Pangalan',
  '_m._yhzh': 'Account',
  '_m._yhlx': 'Uri',
  '_m._yhly': 'Routing',
  '_m._yhdm': 'Code',
  '_m._yhbz': 'Tala',
  '_m._fzxx': 'Kopyahin ang Impormasyon',

  '_m._zts': 'Mga Tip',

  '_m._zyd1': '1. Pakitiyak nang mabuti ang pangalan, numero ng account, at bank code ng tatanggap kapag naglilipat ng pondo. Ang anumang pagkakamali ay maaaring magresulta sa pagkawala ng padala.',

  '_m._zyd2': "2. Inirerekomenda na piliin ang 'Tanggapin ng Nagpapadala ang lahat ng bayarin' upang maiwasan ang kakulangan ng pondo dahil sa mga bawas sa bangko ng tagapamagitan.",

  '_m._zyd3': '3. Ang mga paglilipat ay karaniwang tumatagal ng 1-3 araw ng negosyo. Mangyaring maging matiyaga. Kung mayroon kang anumang mga katanungan, mangyaring makipag-ugnayan sa serbisyo sa customer.',

  '_m._zyd4': '4. Kung mayroon kang anumang iba pang mga katanungan, mangyaring makipag-ugnayan sa serbisyo sa customer.',

  '_m._jyh': 'Numero ng Transaksyon',

  '_m._jyje': 'Halaga',

  '_sp._dbye': 'Balanseng VOD',
  '_sp.hzye': 'Paglilipat',
  '_sp._txje': 'Halaga ng Paglilipat',
  '_sp._qsrtxje': 'Mangyaring mag-input ng halaga ng paglilipat',
  '_sp._ljhz': 'Lipat Kaagad',
  '_sp._yebz': 'Hindi sapat na balanse',
  '_sp._qshuru': 'Mangyaring mag-input ng tamang halaga ng paglilipat',
  '_sp._fanh': 'Bumalik',

  '_sp._tliu': 'Paglalagay ng Ad',
  '_sp._xzgj': 'Pumili ng Bansa',
  '_sp._cdcw': 'Error sa Pag-encode ng Video',
  '_ggtf._hot': 'Sikat',
  '_tl._tlsj': 'Oras ng Ad',
  '_tl._xzxb': 'Pumili ng Kasarian',
  '_tl._nan': 'Lalaki',
  '_tl._nv': 'Babae',
  '_tl._hunhe': 'Halo',
  '_tl._xznl': 'Pumili ng Edad',
  '_sp._us': 'Estados Unidos',
  '_sp._en': 'United Kingdom',
  '_sp._jp': 'Hapon',
  '_sp._fr': 'Pransya',
  '_sp._kr': 'Timog Korea',
  '_sp._de': 'Alemanya',
  '_sp._id': 'India',
  '_sp._in': 'Indonesia',
  '_sp._au': 'Australia',
  '_sp._es': 'Espanya',
  '_sp._my': 'Malaysia',
  '_sp._cn': 'Tsina',
  '_ggtf._fanhui': 'Bumalik',
  '_ggtf._jymmts': 'Mangyaring kumpirmahin ang halaga ng transaksyon at ilagay ang iyong password',
  '_wdtg._wjl_desc': 'Hindi ka pa lumalahok sa anumang kampanya sa advertising',
  '_wd._jxz': 'Isinasagawa',
  '_wd._djs': 'Naghihintay ng Settlement',
  '_wd._ywc': 'Nakumpleto',
  '_wd._jz': 'Apurahan',
  '_wd._hz': 'Transfer',

  '_tl._tlfbqk': 'Distribusyon ng Gastos sa Ad',
  '_tl._tlfbqk_desc': 'Araw 1-5: 5% (Cold Start Phase), Araw 6-10: 20% (Content Validation Phase), Araw 11-15: 40% (IP Building Phase), Araw 16-20: 35% (Short Drama Matrix Phase)',

  '_nhz._sm': 'Pagkatapos ng transfer, ang halaga ay ililipat sa video wallet para ma-unlock ang video content',
  '_nhz._zhzz': 'Nagta-transfer...',
  '_nhz._zzcg': 'Matagumpay ang transfer',
  '_nhz._zhzsb': 'Nabigo ang transfer, pakisubukan muli',
  '_m._fzcg': 'Matagumpay na nakopya',
  '_m._fzsb': 'Nabigo ang pagkopya, pakikopya nang manu-mano',
  '_m._zwfzxx': 'Walang impormasyong makokopya',
  '_tx._qb': 'Lahat',
  'activity.detail': 'Detalye ng Aktibidad',
  'activity.noDesc': 'Walang paglalarawan ng aktibidad',
  'activity.desc': 'Paglalarawan ng Aktibidad',
  'activity.requirements': 'Mga Kinakailangan sa Pakikilahok',
  'activity.minInvest': 'Minimum na Pamumuhunan',
  'activity.vipLevel': 'Antas ng VIP',
  'activity.avgParticipation': 'Karaniwang Pakikilahok',
  'activity.avgParticipationDesc': 'beses',
  'activity.country': 'Pumili ng Bansa',
  'activity.deliveryTime': 'Oras ng Pag-aanunsiyo',
  'activity.deliveryTimeDesc': 'araw',
  'activity.gender': 'Pumili ng Kasarian',
  'activity.male': 'Lalaki',
  'activity.female': 'Babae',
  'activity.mixed': 'Halo',
  'activity.age': 'Pumili ng Edad',
  'activity.amount': 'Halaga ng Pagbili',
  'activity.back': 'Bumalik',
  'activity.join': 'Sumali Ngayon',
  emptyData: 'Walang Data',
  emptyDataDesc: 'Walang kalahok na kampanya sa ad',
  completedtlement: 'Nag-expire na',
  preheat: 'Nag-iinit',
  progress: 'Isinasagawa',
  settlement: 'Naghihintay ng Settlement',
  transfered: 'Na-transfer',
  completed: 'Nakumpleto',
  activityCode: 'Kodigo ng Aktibidad',
  touzAmount: 'Halaga ng Pamumuhunan',
  activityDays: 'Mga Araw ng Aktibidad',
  joinTime: 'Oras ng Pagsali',
  playSource: 'Distribusyon ng Pinagmulan ng Pag-play',
  allPlatforms: 'Lahat ng Platform',
  other: 'Iba pa',
  totalPlayNum: 'Kabuuang Pag-play',
  incomeSummary: 'Buod ng Kita',
  totalPay: 'Binayarang Bayad sa Copyright',
  totalIncome: 'Kabuuang Kita',
  copyrightRatio: 'Bahagi ng May-ari ng Copyright',
  promotionIncome: 'Kita sa Promosyon',
  copyrightIncome: 'Bahagi sa Copyright',
  playNum: 'Bilang ng Pag-play',
  buyNum: 'Pag-play on-demand',
  incomeRate: 'Rasyon ng Bahagi',
  yjIncome: 'Tinantyang Kita',
  paid: 'Bayad Na',
  timeout: 'Nag-time Out',
  transfer: 'Ilipat Ngayon',
  loading: 'Naglo-load...',
  loadMore: 'Mag-load Pa',
  noMore: 'Wala Nang Iba Pa',
  nightTime: 'Panahon ng Gabi',
  morningTime: 'Panahon ng Umaga',
  afternoonTime: 'Panahon ng Hapon',
  eveningTime: 'Panahon ng Gabi',
  '_h._tc': 'Mag-logout',
  periodPayment: 'Pagbabayad ayon sa Panahon',
  periodPaymentDesc: 'Ang settlement ay nangyayari 4 na beses araw-araw sa 4 na panahon, maaari kang magbayad ng mga bayad sa copyright bawat panahon',

  day: 'araw',
  '_dl._hy': 'Maligayang pagbabalik',
  '_dl._cj': 'Lumikha ng Account',
  '_dl._zmm': 'I-reset ang Password',
  '_dl._hyDesc': 'Mag-login sa iyong account upang magpatuloy sa pagtuklas ng magagandang nilalaman',
  '_dl._cjDesc': 'Sumali sa ReelShortBiz at simulan ang iyong kapana-panabik na paglalakbay',
  '_dl._zmmDesc': 'Ipasok ang iyong email at magpapadala kami ng verification code para i-reset',
  '_dl._hlgqsp': 'Napakaraming HD na pelikula at video resources',
  '_dl._gxhty': 'Mga personalized na recommendation algorithm',
  '_dl._ffddsp': 'Mayamang maikling video',
  '_dl._dlzh': 'Mag-login',
  '_dl._sdndyx': 'Ipasok ang iyong email at password upang magpatuloy',
  '_dl._email': 'Email Address',
  '_dl._qsryx': 'Pakilagay ang iyong email address',
  '_dl._dlmm': 'Password',
  '_dl._qsrmm': 'Pakilagay ang iyong password',
  '_dl._wjmm': 'Nakalimutan ang password?',
  '_dl._immdl': 'Mag-login Ngayon',
  '_dl._hmyzh2': 'Wala kang account?',
  '_dl._ljzc2': 'Mag-sign Up Ngayon',
  '_dl._cjzh': 'Lumikha ng Account',
  '_dl._jswmd': 'Sumali sa ReelShortBiz at simulan ang iyong kapana-panabik na paglalakbay',
  '_zh._qszmm': 'Pakilagay ang iyong password',
  '_zh._qrmm': 'Kumpirmahin ang Password',
  '_zh._qmm': 'Pakilagay muli ang password',
  '_zc._yqm': 'Invitation Code',
  '_zc._sryqm': 'Pakilagay ang invitation code',
  '_dl._yzm': 'Verification Code',
  '_dl._qsryzm': 'Pakilagay ang verification code',
  '_dl._yjyzh': 'May account ka na?',
  '_dl._zcbsty2': 'Sa pagrehistro, sumasang-ayon ka sa',
  '_dl._zcbstyDesc': 'Patakaran sa Privacy',
  '_dl._newmm': 'Bagong Password',
  '_dl._qszxmm': 'Pakilagay ang bagong password',
  '_dl._qrmm': 'Kumpirmahin ang Password',
  '_dl._qzcsrmm': 'Pakilagay muli ang bagong password',
  '_dl._czmm': 'I-reset ang Password',
  '_dl._xqlmm': 'Naalala mo na ang iyong password?',
  '_dl._fhdl': 'Bumalik sa Pag-login',
  '_dl._srdllmmbyz': 'Hindi magkatugma ang mga password',
  '_dl._czcg': 'Matagumpay na na-reset ang password',
  '_h._zc': 'Magrehistro',
  // '_ybp._wdsy': 'Aking Kita',
  '_ybp._jrsy': 'Kita Ngayong Araw',
  '_ybp._jztr': 'Kumpara sa kahapon',
  '_ybp._bfl': 'Mga Panonood',
  '_ybp._dbl': 'Mga Hiling',
  '_ybp._syqs': 'Trend ng Kita',
  // '_ybp._jr': 'Ngayon',
  '_ybp._t': 'araw',
  // '_ybp._dqye': 'Balanseng Account',
  '_ybp._djs': 'Naghihintay ng Settlement',
  '_ybp._zhl': 'Conversion Rate',
  '_ybp._sjgl': 'Pangkalahatang-ideya ng Data',
  '_ybp._zrsy': 'Kita Kahapon',
  '_ybp._bysy': 'Kita Ngayong Buwan',
  '_ybp._yysj': 'Operational Data',
  '_ybp._zr': 'Kahapon',
  '_ybp._zjfrs': 'Kabuuang Nagbabayad na User',
  '_ybp._mtdqje': 'Halagang Babayaran Bukas',
  '_ybp._jsy': 'Netong Kita',
  '_ybp._bqfy': 'Plano ng Pagbabayad ng Copyright',
  '_ybp._yzf': 'Bayad Na',
  '_ybp._qzf': 'Pumunta sa Pagbabayad',
  '_ybp._bqfyts': 'Pagkatapos magbayad ng mga copyright fees, ang iyong kita at mga karapatan ay prayoridad',
  '_ybp._syjl': 'Kasaysayan ng Kita',
  '_ybp._ckgd': 'Tumingin Pa',
  '_ybp._ssdt': 'Live na Update',
  '_ybp._bzzx': 'Help Center',
  '_ybp._lxkf': 'Makipag-ugnayan sa Support',
  '_ybp._zrxz': 'Kita Kahapon',
  '_ybp._zdsy': 'Kabuuang Kita',
  '_ybp._qygy': 'Noong Nakaraang Buwan',
  '_ybp._jsjl': 'Kasaysayan ng Settlement',
  '_ybp._hzjl': 'Kasaysayan ng Transfer',
  '_ybp._jfzq': 'minuto ang nakalipas',
  '_ybp._fzq': 'oras ang nakalipas',
  '_ybp._djs_mt': 'Halaga ng settlement bukas',
  '_yj._rule': 'Mga Panuntunan ng Platform',

  '_bq._jjks': 'Simulan na ngayon',
  '_bq._jxz': 'Isinasagawa',
  '_bq._jks': 'Oras bago mag-umpisa',
  '_bq._jjs': 'Oras bago magtapos',
  '_bq._t': 'araw',
  '_bq._h': 'oras',
  '_bq._m': 'min',
  '_bq._s': 'seg',
  '_bq._kssj': 'Oras ng pagsisimula',
  '_bq._jssj': 'Oras ng pagtatapos',
  '_bqq._tzdj': 'Presyo bawat yunit',
  '_bqq._hdts': 'Bilang ng araw ng event',
  '_bqq._vip': 'Antas ng VIP',
  '_bqq._rjcy': 'Karaniwang pakikilahok',
  '_bqq._cs': 'beses',
  '_bqq._ysjd': 'Progresso ng nabenta',
  '_bqq._ljqg': 'Bilhin ngayon',
  '_bqq._zbkqg': 'Hindi kasalukuyang mabibili',
  '_bqq._jzz': 'Naglo-load',
  '_bqq._jzgd': 'Mag-load pa',
  '_bqq._wz': 'Wala nang iba',

  '_sp._gdsj': 'Kabuuang {n} mga episode',
  '_sy._jl': 'Nakabinbin na Talaan ng Settlement',
  '_ybp._zsy': 'Kabuuang Kita',
  '_ybp._djsjl': 'Nakabinbin na Talaan ng Settlement',
  '_ybp._bqbm': 'Kodigo',
  '_ybp._je': 'Halaga',
  '_ybp._sj': 'Oras',
  '_sy._djs': 'Nakabinbin',
  '_sy._yjs': 'Naayos',
  '_sy._gdstjl': 'Kabuuang {n} mga tala',
  '_sy._gjd': 'Kabuuang {n}',

  '_sp.tgdy': 'Ang halaga ay hindi maaaring mas mababa sa {a}',
  '_sp.tggy': 'Ang halaga ay hindi maaaring mas mataas sa {a}',

  '_tg._zdyje': 'Halaga na Na-customize'
}
